export const speciality = [
    "Acupuncture",
    "AI in Vet Medicine",
    "Anesthesia and Analgesia",
    "Animal welfare",
    "Avian",
    "Bacteria/Mycology",
    "Beef Cattle",
    "Behavior",
    "Business/ Practice management consulting",
    "Canine Medicine",
    "Cardiology",
    "Clinical Pharmacology",
    "Dairy medicine",
    "Dentistry (Small animal)",
    "Dentistry (Equine)",
    "Dermatology",
    "Emergency and Critical Care",
    "Equine Medicine",
    "Exotic Companion Animal",
    "Feline Medicine",
    "Food Animal",
    "Immunology",
    "Internal Medicine (Small Animal)",
    "Internal Medicine (Large Animal)",
    "Laboratory Animal Medicine",
    "Microbiology",
    "Neurology",
    "Nutrition",
    "Oncology",
    "Ophthalmology",
    "Other",
    "Pain Management",
    "Parasitology",
    "Pathology (Anatomic)",
    "Pathology (Clinical)",
    "Poultry",
    "Preventative medicine/Primary care",
    "Primary care",
    "Radiation Oncology",
    "Radiology",
    "Rehabilitation Medicine",
    "Reptile/Amphibian",
    "Shelter Medicine",
    "Sports Medicine (Canine)",
    "Sports Medicine (Equine)",
    "Surgery (Large Animal-ALL)",
    "Surgery (Large Animal- EQUINE)",
    "Surgery (Large Animal- FARM ANIMAL/COMPANION)",
    "Surgery (Small Animal- ALL)",
    "Surgery (Small Animal- ORTHOPEDICS)",
    "Surgery (Small Animal- SOFT TISSUE)",
    "Surgery (Small Animal- SURGICAL ONCOLOGY)",
    "Swine Health",
    "Theriogenology",
    "Toxicology",
    "Transcriptionist",
    "Virology",
    "Zoological Medicine" ,
]

// Specialties that have custom intake forms available
// Used when specialty intake is ENABLED
export const specialtyIntakeForms = [
    "Behavior",
    "Dermatology",
    "Emergency and Critical Care",
    "Internal Medicine",
    "Oncology",
    "Ophthalmology"
]

/**
 * Get the appropriate specialty list based on feature flag
 * @param specialtyIntakeEnabled - Whether specialty intake feature is enabled
 * @returns Array of specialty names
 */
export function getSpecialtyList(specialtyIntakeEnabled: boolean): string[] {
    return specialtyIntakeEnabled ? specialtyIntakeForms : speciality;
}

// Specialties that support both initial and recheck consultation types
// Emergency and Critical Care supports initial and non-case-question only (no recheck)
export const specialtiesWithRecheck = [
    "Behavior",
    "Dermatology",
    "Emergency and Critical Care",
    "Internal Medicine",
    "Oncology",
    "Ophthalmology"
]

// Specialties that require species selection (Canine vs Feline)
export const specialtiesWithSpeciesSelection = [
    "Behavior"
]

// Specialties that do NOT support recheck (only initial and non-case-question)
export const specialtiesWithoutRecheck = [
    "Emergency and Critical Care"
]